import { useEffect, useState } from 'react';
import StrapiService from '@/services/StrapiService';
import { initializeRootStore } from '@/stores';
import { getEnv, getSnapshot } from 'mobx-state-tree';
import { IStory } from '@/stores/Stories';
import StoriesScene from '@/scenes/Stories';

const StoryPage = ({ pageContent }) => {
  const [loaded, setLoaded] = useState<boolean>(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  if (loaded) {
    return <StoriesScene content={pageContent} />;
  }

  return <></>;
};

export const getStaticPaths = async () => {
  const strapiService = new StrapiService();

  const stories = await strapiService.getAllStories();

  const paths = stories.map((story: IStory) => {
    return {
      params: { url: story.slug },
    };
  });

  return {
    paths,
    fallback: false,
  };
};

export const getStaticProps = async ({ params }) => {
  const rootStore = initializeRootStore();

  const strapiService = new StrapiService();
  const story = await strapiService.getSingleStory(params.url);

  await rootStore.storiesStore.setItems([story]);

  await rootStore.uiStore.openModal({ type: 'story', instance: params.url });

  const pageContent = await getEnv(rootStore).strapiService.get(
    '/stories-page',
    {
      params: {
        'populate[banner][populate]': '*',
        'populate[cta][populate]': '*',
      },
    },
  );

  return {
    props: {
      initialState: getSnapshot(rootStore),
      pageContent: pageContent.data.data.attributes,
    },
  };
};

export default StoryPage;
